import Vue from 'vue';
import { BrowserMergen } from '@discovery/mergen-browser';
import ValidatorTr from 'vee-validate/dist/locale/tr';
import VeeValidate, { Validator } from 'vee-validate';
import Gtm from '@webcore/grace/plugins/Gtm.plugin';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

const isProduction = process.env.VUE_APP_MODE === 'production';

try {
  BrowserMergen.init({
    app: {
      name: process.env.VUE_APP_PROJECT_NAME,
      version: process.env.VUE_APP_RELEASE_VERSION || '1.0.0',
      environment: isProduction ? 'production' : 'stage',
    },
    instrumentations: {
      webVitals: { enable: true },
      errors: { enable: true },
      tracing: { enable: true },
    },
    pathMatchers: [
      '/static-pages/*',
      '/cargoStatus',
      '/alternativeDeliveryStaticpage',
      '/digitalDeliveryStaticpage',
      '/kasim-kampanyalari',
      '/mobile-kasim-kampanyalari',
      '/yukselen-yildizlar-programi',
      '/mobile-static-page',
    ],
  }).observe();
} catch (err) {
  // eslint-disable-next-line
  console.log('mergen init error');
}

const VeeValidateConfig = {
  fieldsBagName: 'validationFields',
  events: 'input', // 'change|input',
};
Vue.use(VeeValidate, VeeValidateConfig);
Validator.localize('tr', ValidatorTr);

Vue.use(Gtm);

Vue.config.productionTip = false;

window.currentApp = new Vue({
  router,
  store,
  render: (h) => h(App),
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      cdnPath: process.env.VUE_APP_CDN_URL,
    };
  },
}).$mount('#app');
